<template>
  <div>
    <v-tooltip v-if="isBtn" top>
      <template v-slot:activator="{ on, attr }">
        <v-btn
          :loading="loading"
          v-bind="[$attrs, attr]"
          @click="dialog = true"
          v-on="on"
        >
          <slot name="default">
            <v-icon>mdi-crosshairs</v-icon>
          </slot>
        </v-btn>
      </template>

      <span>انتخاب کاربر</span>
    </v-tooltip>

    <v-text-field
      v-else
      :append-outer-icon="value ? 'mdi-close-circle-outline' : ''"
      :hide-details="hideDetails"
      :loading="loading"
      :value="name"
      append-icon="mdi-crosshairs"
      class="cursor-pointer"
      dense
      label="انتخاب کاربر"
      outlined
      readonly
      @click="dialog = true"
      @click:append-outer="clearUser"
    />

    <custom-popup
      v-model="dialog"
      :cons="cons"
      hide-overlay
      max-width="800px"
      scrollable
    >
      <v-card :loading="loading" outlined>
        <v-card-actions>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="my-3"
            hide-details
            label="جستجو"
            outlined
          />
        </v-card-actions>

        <v-list style="background: white; z-index: 999">
          <v-list-item-group v-model="selectedItem" color="primary">
            <template v-for="(x, i) in manufacturers">
              <v-list-item v-if="x" :key="i" @click="picked = x">
                <v-list-item-content>
                  <v-list-item-title v-text="x.name + ' ' + x.lastName" />
                  <v-list-item-subtitle v-text="x.username">
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action v-if="x.id === value">
                  <v-icon>mdi-check</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>

        <v-card-actions
          class="justify-end"
          style="background: white; z-index: 999"
        >
          <hr />
          <v-spacer />

          <pagination
            v-if="data && data.data"
            :data="data"
            @page="onPagination"
          />
        </v-card-actions>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
import Pagination from "../../content/fragments/pagination";

export default {
  name: "usersPicker",

  components: { Pagination },

  props: {
    value: [Number],
    hideDetails: Boolean,
    isBtn: Boolean,
  },

  data() {
    return {
      cons: {
        title: "انتخاب کاربر",
        buttons: [
          { type: "close", handler: (this.dialog = false) },
          { type: "submit", handler: this.pick, disabled: () => !this.picked },
        ],
      },
      selectedItem: null,
      dialog: false,
      loading: false,
      search: null,
      manufacturers: [],
      data: {},
      picked: null,
      name: "",
      model: [],
      tableProps: {
        page: 1,
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      url: `${url}/admin/user`,
      // url: `/admin/users`
    };
  },

  created() {
    this.manufacturers.find((x) => {
      if (x.id === this.value) {
        this.name = x.name;
      }
    });
  },

  watch: {
    value(val) {
      if (!val) this.name = null;
    },
    dialog(val) {
      if (val) {
        this.fetch(this.url);
      }
    },
    search(val) {
      if (val.length >= 3) {
        this.tableProps.search = val;
        this.fetch(this.url, this.tableProps);
      }
    },
  },

  methods: {
    fetch(url = this.url, props = this.tableProps) {
      this.loading = true;

      try {
        this.$api
          .get(
            `/admin/user?page=${props.page}&search=${props.search}&length=${props.length}&column=${props.column}&dir=${props.dir}`,
          )
          .then(({ data }) => {
            if (data.data.message) {
              this.$toast.clear();
              this.$toast.warning(data.data.message, { timeout: 3500 });
            }

            this.data = data.data;
            this.picked = this.selectedItem = null;

            this.manufacturers = [
              {
                id: "-1",
                name: "سایت",
                lastName: "",
                username: null,
              },
            ];

            this.manufacturers = this.manufacturers.concat(data.data.data);
          })
          .catch(({ response }) => this.$toast.error("خطا در دریافت کاربران!"))
          .finally(() => (this.loading = false));
      } catch (e) {
        this.loading = false;
      }
    },
    pick(x = this.picked) {
      try {
        this.name = x.name + " " + x.lastName;
        this.$emit("input", x.id);
      } catch (e) {
        console.log("error in pick user: ", e);
      }
      // this.model = x;
      this.dialog = false;
    },
    clearUser() {
      this.name = "";
      this.$emit("input", null);
    },
    onPagination(e) {
      if (e !== this.tableProps.page) {
        this.tableProps.page = e;
        this.$nextTick(() => {
          this.fetch();
        });
      }
    },
  },
};
</script>

<style scoped></style>
